import React, { useEffect, useState } from 'react'
import Modal from 'react-modal'
import { connect, useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.scss'
import { ChoiceQuestion, MultichoiceQuestion, TextQuestion, MatchQuestion, FinalWindow } from './Components'
import { TestContext } from '../../utils/context'
import { addQuestionAnswer, setGrade as getStatistic, startTest } from '../../actions/testing'
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Timer from '../../assets/Timer/Timer'
import Checkbox from '../../assets/CustomCheckbox/CustomCheckbox'

const mapStateToProps = ({testing}) => {
  const { statistic } = testing
  const {loading} = testing.questions
  return {loading, statistic}
}



const QuestionModal = ({
  isOpen,
  data,
  closeTestHandler,
  nextQuestion,
  prevQuestion,
  nextButtonDisabled,
  prevButtonDisabled,
  questionInd,
  questions,
  question,
  testFinished,
  addQuestionAnswer,
  setQuestionPassed,
  setCurrentQuestion,
  statistic,
  getStatistic,
  testId,
  timeOver,
  setTimeOver,
  finishTest,
  can_try,
  repeatHandler
}) => {
  
  const questionTitle = testFinished ? '' : `${questionInd + 1} / ${questions.length}`

  const dispatch = useDispatch()
  const { loading } = useSelector(state => state.testing.files)

  useEffect(() => {
    isOpen && dispatch(startTest(testId))
  }, [isOpen])
  


  const renderQuestion = (question, index) => {
    const visible = questionInd === index
    const props ={ question, visible, setQuestionPassed: setQuestionPassed(index) }
    switch (question.question_type) {
      case 2: return <MultichoiceQuestion key={index} {...props}/>
      case 3: return <TextQuestion key={index} {...props} />
      case 4: return <MatchQuestion key={index} {...props} />
      default: return <ChoiceQuestion key={index} {...props} />
    }
  }

  const navPanel = (
    <div className={styles.navPanel}>
      {questions.map(({passed}, index) => {
        const classNames = `${styles.checkbox} ${question === index ? styles.activeCB : ''}`
        return (
          <div key={index} onClick={setCurrentQuestion(index)}>
            <Checkbox checked={passed} className={classNames}/>
            <div>{index + 1}</div>
          </div>
        )
      })}
    </div>
  )

  const contextValue = {
    data,
    addQuestionAnswer,
    getStatistic,
    statistic,
    nextQuestion,
    closeTestHandler,
    testId,
    navPanel,
    finishTest,
    can_try,
    repeatHandler,
    timeOver
  }

  
  return (
    <Modal
      style={{ content: {borderColor: 'grey'}}}
      isOpen={isOpen}
    >
      <TestContext.Provider value={contextValue}>
        <div className={styles.modal}>

          <FaChevronLeft disabled={prevButtonDisabled} onClick={prevQuestion}/>

          <div>
            <div className={styles.timerBlock}>
              <Timer
                over={timeOver}
                setOver={setTimeOver}
                handleFinal={finishTest}
                minutes={parseInt(data.total_worktime) || 15}
                paused={loading}
              />
            </div>
            <h5>{questionTitle}</h5>
            {questions.map(renderQuestion)}
            {testFinished && <FinalWindow/>}
          </div>

          <FaChevronRight disabled={nextButtonDisabled} onClick={nextQuestion}/>
        
        </div>

      </TestContext.Provider>
    </Modal>
  )
}

export default connect(mapStateToProps, { addQuestionAnswer, getStatistic })(QuestionModal)